import { SearchParams } from '../CustomerSearch/components/CustomerSearchBox/CustomerSearchBox';
import { createCustomerInitialValues } from './components/CreateCustomerForm/CreateCustomerFormDefinitions';

const getCreateCustomerInitialValues = (searchParams: SearchParams) => {
  const initialValues = createCustomerInitialValues;
  initialValues.customer.name = searchParams.name || '';
  initialValues.customer.address.street = searchParams.street || '';
  initialValues.customer.address.unit = searchParams.unit || '';
  initialValues.customer.address.zip = searchParams.zip || '';
  initialValues.customer.contacts[0].value = searchParams.phone || '';
  return initialValues;
};

export default getCreateCustomerInitialValues;
